/**
 * Feature flags come in as an array of objects, such as
 * [{ name: "feature1", enabled: false }, { name: "feature2", enabled: true }]
 * This "flattens" that array into a single object with key/value pairs
 * of { feature1: false, feature2: true }
 * @params Array of objects with `name` and `enabled` properties
 * @returns Object of keys corresponding to `name` and values corresponding to `enabled`, per object
 */
export default featureFlagsArray => {
  let featureFlags = {};

  featureFlagsArray.map(flag => {
    featureFlags[flag.name] = flag.enabled;
  });

  return featureFlags;
};
